module.exports = __webpack_public_path__ + "static/media/lockup-colour.8e8a7d65.png";